import { updatesItems } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-8">
          最近更新
        </h2>
        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-200"></div>
          <div className="space-y-4">
            {updatesItems.map((item) => (
              <a
                key={item.id}
                href="#updates"
                className="flex items-start gap-5 group cursor-pointer"
              >
                <div className="relative z-10 w-[9px] h-[9px] rounded-full bg-primary-500 mt-1.5 flex-shrink-0 ring-2 ring-background-50 group-hover:scale-125 transition-transform"></div>
                <div className="flex-1 min-w-0 pb-4 border-b border-background-200/70">
                  <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3">
                    <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                      {item.title}
                    </h3>
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{item.time}</span>
                  </div>
                  <p className="mt-1 text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}